import { render, staticRenderFns } from "./PublishShiftsSvg.vue?vue&type=template&id=3be57de5&scoped=true&"
import script from "./PublishShiftsSvg.vue?vue&type=script&lang=ts&"
export * from "./PublishShiftsSvg.vue?vue&type=script&lang=ts&"
import style0 from "./PublishShiftsSvg.vue?vue&type=style&index=0&id=3be57de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be57de5",
  null
  
)

export default component.exports